import React from 'react'
import _ from 'lodash'
import { ConfirmationSummaryProps } from '../../CampaignModalSkeleton/CampaignModalSkeleton.types'
import { ProductDiscountThresholdRuleState } from './types'
import {
	RuleSummaryArrow,
	RuleSummaryEligibleProducts,
	RuleSummaryMechanicsRow,
	RuleSummaryStatBadge,
} from '../../CampaignModalSkeleton/components'

export function ProductDiscountThresholdConfirmationSummary({
	rule,
}: ConfirmationSummaryProps<ProductDiscountThresholdRuleState>) {
	const names = _.uniq(rule.products.map((p) => {
		const row = rule.purchasedProducts.find((x) => x.productKey === p.productKey)
		return row?.productName || p.productKey
	}))

	return (
		<>
			<RuleSummaryMechanicsRow>
				<RuleSummaryStatBadge
					value={`${rule.threshold} €`}
					caption="seuil panier"
					minWidth={72}
				/>
				<RuleSummaryArrow />
				<RuleSummaryStatBadge
					value={`−${rule.discount}%`}
					caption="sur produits ciblés"
					tone="accent"
					minWidth={72}
				/>
			</RuleSummaryMechanicsRow>
			<RuleSummaryEligibleProducts names={names} />
		</>
	)
}
